import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";


// Wrap content with this component to make them fade in u scroll to them
const AnimatedCard = (props) => {
  //this is important step to use the ScrollTrigger plugin
  gsap.registerPlugin(ScrollTrigger);
  //used to reference the HTML to the animation
  const container = useRef(null);

  //create the animation when the component is rendered
  useEffect(() => {
    //The animation to pull the div from the bottom and opacity 0 
    // uncomment markers:true, to debug the animation 
    gsap
      .timeline()
      .from(container.current, {
        yPercent: 50,
        opacity: 0,
        ease: "easeIn",
        scrollTrigger: {
          trigger: container.current,
          start: "top 95%",
          end: "top 80%",
          scrub: 2,
          // markers:true,
        },
      })
     
  }, []);

  return (
    <div className={props.className} ref={container}>
      {props.children}
    </div>
  );
};
export default AnimatedCard;
